import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import TooltipLable from './tooltip-label';
import style from './style.module.less';
import { emptyArray } from 'ui-components/default-props/empty';
import messages from './messages';

const CustomTooltipShipmentsByAge = ({ payload = emptyArray }) => {
  const selectedDate = payload?.[0]?.payload?.interval;
  const countRaw = payload?.[0]?.payload?.count || 0;

  return (
    <>
      <TooltipLable selectedDate={selectedDate} />
      <div className={style.content}>
        <FormattedMessage
          {...messages.shipmentsByAgeShippedTotals}
          values={{
            countRaw,
            count: <FormattedNumber value={countRaw} />,
          }}
        />
      </div>
    </>
  );
};

CustomTooltipShipmentsByAge.propTypes = {
  payload: PropTypes.arrayOf(
    PropTypes.shape({
      payload: PropTypes.shape({
        count: PropTypes.number,
        interval: PropTypes.string,
      }),
    }),
  ),
};

export default CustomTooltipShipmentsByAge;
